import { Flex, Form, FormContext } from 'dash-ui';
import { useContext, useMemo } from 'react';
import { getCountiesByStateName } from 'dash-common';
import { useTranslation } from 'react-i18next';
import { FormFields } from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/constants/constants';
import useValidation from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/hooks/useValidation';

const CountySelect = () => {
  const { t } = useTranslation(['forms', 'common', 'pages']);
  const { formState, formErrors, stateHandlers } = useContext(FormContext);
  const { state } = formState;
  const valid = useValidation();

  const handleCountySelect = (value: string) => {
    if (value) {
      stateHandlers[FormFields.County](value);
      valid(FormFields.County, value);
    }
  };
  const countiesOptions = useMemo(() => {
    const counties = getCountiesByStateName(state);
    return counties.map((value: string) => ({
      label: value,
      value,
    }));
  }, [state]);

  return (
    <Flex flexDirection="column" flex={1} mr={2}>
      <Form.Label required>{t('forms:labels.county')}</Form.Label>
      <Form.Select
        menuPortalZIndex="auto"
        disabled={!formState.state || !countiesOptions.length}
        value={formState.county}
        options={countiesOptions}
        placeholder={t('forms:placeholders.selectOne')}
        onChanged={handleCountySelect}
        w="100%"
        $errorType={formErrors[FormFields.County]?.type}
      />
      <Form.Feedback $errorType={formErrors[FormFields.County]?.type}>
        {formErrors[FormFields.County]?.message}
      </Form.Feedback>
    </Flex>
  );
};

export default CountySelect;
